import { reactive } from 'vue';

export type ToastType = 'error' | 'warning' | 'info';

export interface Toast {
    id: number;
    message: string;
    type: ToastType;
}

let nextId = 0;
const TOAST_DURATION_MS = 5000;

export const toasts: Toast[] = reactive([]);

export function showToast(message: string, type: ToastType = 'error') {
    const msg = typeof message === 'string' && message ? message : 'An unexpected error occurred.';
    // Don't stack duplicates: if this exact message is already visible, reset nothing
    // (just let the existing one time out).
    if (toasts.some((t) => t.message === msg && t.type === type)) return;

    const id = ++nextId;
    toasts.push({ id, message: msg, type });
    setTimeout(() => dismissToast(id), TOAST_DURATION_MS);
}

export function dismissToast(id: number) {
    const idx = toasts.findIndex((t) => t.id === id);
    if (idx !== -1) toasts.splice(idx, 1);
}
